import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

function checkPixelsAboveThreshold(pixelData, threshold) {
  const numPixels = pixelData.length / 4;

  for (let i = 0; i < numPixels; i++) {
    const startIndex = i * 4;
    const red = pixelData[startIndex];
    const green = pixelData[startIndex + 1];
    const blue = pixelData[startIndex + 2];
    const alpha = pixelData[startIndex + 3];

    if (red < threshold || green < threshold || blue < threshold || alpha < threshold) {
      return false;
    }
  }

  return true;
}


function determine(obj, {
  a4h,
  a4w
}) {
  const {
    renderedHeight,
    imgHeight,
    canvas,
    ctx
  } = obj


  const lastPixelData = ctx.getImageData(0, renderedHeight - 4 + Math.min(imgHeight, canvas.height - renderedHeight) - 1, canvas.width, 1).data;

  let bo = checkPixelsAboveThreshold(lastPixelData, 233)
 
  let imgHeight1 = Math.floor((a4h - 1) * canvas.width / a4w); // 按A4显示比例换算一页图像的像素高度
  let minHeight
  if (!bo) {
    let h = a4h - 0.5
   return determine({
      renderedHeight,
      canvas,
      ctx,
      imgHeight: imgHeight1
    }, {
      a4h: h,
      a4w
    })
  } else {
    
    minHeight = Math.min(imgHeight, canvas.height - renderedHeight)
    
    return {
      imgHeight:imgHeight1,
      minHeight,
    }
  }
  


}

export default {
  install(Vue, options) {
    /**
     * 
     * @param {*} reportName 下载时候的标题
     * @param {*} isDownload  是否下载默认为下载，传false不下载
     */
    Vue.prototype.getPdf = function(reportName, isDownload = true) {

      //     var target = document.getElementsByClassName("right-aside")[0];
      // target.style.background = "#FFFFFF";
      return new Promise((resolve, reject) => {

        var title = reportName;
        let htmlDom = document.querySelector('#pdfDom')
        html2Canvas(htmlDom, {
          // allowTaint: true,
          // foreignObjectRendering: true
          logging: false, //日志开关，便于查看html2canvas的内部执行流程
          width: htmlDom.clientWidth, //dom 原始宽度
          height: htmlDom.clientHeight,
          scrollY: 0,
          scrollX: 0,
          useCORS: true // 【重要】开启跨域配置
        }).then( async(canvas) => {
          const pdf = new JsPDF('p', 'mm', 'a4'); // A4纸，纵向

          const ctx = canvas.getContext('2d');
          let marginWidth = 40
          const a4w = 210 - marginWidth;
          const a4h = (297) - marginWidth; // A4大小，210mm x 297mm，四边各保留20mm的边距，显示区域170x257
          // +16

          let renderedHeight = 0;

          while (renderedHeight < canvas.height) {
            let imgHeight = Math.floor((a4h) * canvas.width / a4w); // 按A4显示比例换算一页图像的像素高度
            const page = document.createElement('canvas');
            page.width = canvas.width;
            page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页

            let minHeight = Math.min(imgHeight, canvas.height - renderedHeight)

           let dddata= await determine({
              renderedHeight,
              imgHeight,
              canvas,
              ctx
            }, {
              a4h,
              a4w
            })
       
            imgHeight=dddata.imgHeight
            minHeight=dddata.minHeight
            page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页

            // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, minHeight), 0, 0);
            pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', marginWidth / 2, marginWidth / 2, a4w, Math.min(a4h, a4w * page.height / page.width)); // 添加图像到页面，保留10mm边距

            renderedHeight += imgHeight;
            if (renderedHeight < canvas.height) {
              pdf.addPage(); // 如果后面还有内容，添加一个空页
            }


          }
          if (isDownload) {
            pdf.save(title + '.pdf')
          }
      
          // 删除本地存储的base64字段
          var pdfData = pdf.output('datauristring') //获取base64Pdf
          resolve(pdfData)
        })
      })
    }
  }
}
